import React from "react";
import FormControl from "@material-ui/core/FormControl";
import {InputLabel, Select} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import MenuItem from "@material-ui/core/MenuItem";

const avatars = [
    'avatar-01.svg',
    'avatar-02.svg',
    'avatar-03.svg',
    'avatar-04.svg',
    'avatar-05.svg',
    'avatar-06.svg',
    'avatar-07.svg',
    'avatar-08.svg',
    'avatar-09.svg',
    'avatar-10.svg',
    'avatar-11.svg',
    'avatar-12.svg',
    'avatar-13.svg',
    'avatar-14.svg',
    'avatar-15.svg',
    'avatar-16.svg',
    'avatar-17.svg',
    'avatar-18.svg',
    'avatar-19.svg',
    'avatar-20.svg',
    'avatar-21.svg',
    'avatar-22.svg',
    'avatar-23.svg',
    'avatar-24.svg',
    'avatar-25.svg',
    'avatar-26.svg',
    'avatar-27.svg',
    'avatar-28.svg',
    'avatar-29.svg',
    'avatar-30.svg',
    'avatar-31.svg',
    'avatar-32.svg',
    'avatar-33.svg',
    'avatar-34.svg',
    'avatar-35.svg',
    'avatar-36.svg',
    'avatar-37.svg',
    'avatar-38.svg',
    'avatar-39.svg',
    'avatar-40.svg',
    'avatar-41.svg',
    'avatar-42.svg',
    'avatar-43.svg',
    'avatar-44.svg',
    'avatar-45.svg',
    'avatar-46.svg',
    'avatar-47.svg',
    'avatar-48.svg',
]

// Standard controlled component
const AvatarSelectControlled = ({value, onChange, initials='A', baseUrl='/assets/images/avatars/'}) => {

    return (
        <FormControl
            variant="outlined"
            margin="dense"
        >
            <InputLabel id="avatar-select-label">Avatar</InputLabel>
            <Select
                labelId="avatar-select-label"
                id="avatarUrl"
                name="avatarUrl"
                label="Avatar"
                value={value || ''}
                onChange={onChange}
            >
                <MenuItem key="avatar-00.png" value="avatar-00.jpg">
                    <Avatar src={baseUrl + 'avatar-00.jpg'}>{initials}</Avatar>
                </MenuItem>
                { avatars.map((value, index) => (
                    <MenuItem key={value} value={value}>
                        <Avatar src={baseUrl + value} height={36} width={36} style={{borderRadius:18}} alt={value}/>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

// React Hook Form 6 version - does not work with RHF 7
// const AvatarSelect = ({defaultValue, register, control,  initials='A', baseUrl='/assets/images/avatars/'}) => {
//
//     return (
//         <FormControl
//             variant="outlined"
//             margin="dense"
//         >
//             <InputLabel id="avatar-select-label">Avatar</InputLabel>
//             <Controller
//                 id="avatarUrl"
//                 name="avatarUrl"
//                 labelId="avatar-select-label"
//                 label="Avatar"
//                 inputRef={register}
//                 defaultValue={defaultValue}
//                 control={control}
//                 as={
//                     <Select>
//                         <MenuItem key="avatar-00.jpg" value="avatar-00.jpg">
//                             <Avatar src={baseUrl + 'avatar-00.jpg'}>{initials}</Avatar>
//                         </MenuItem>
//                         { avatars.map((key, index) => (
//                             <MenuItem key={key} value={key}>
//                                 <img src={baseUrl + key} height={36} width={36} style={{borderRadius:18}} alt={key}/>
//                             </MenuItem>
//                         ))}
//                     </Select>
//                 }
//             />
//         </FormControl>
//     )
//
// }

export default AvatarSelectControlled;